import { render, staticRenderFns } from "./FormularOdoslany.vue?vue&type=template&id=6c243f98&scoped=true"
var script = {}
import style0 from "./FormularOdoslany.vue?vue&type=style&index=0&id=6c243f98&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c243f98",
  null
  
)

export default component.exports